import { Injectable } from '@angular/core';
import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerAndroidScanningLibrary,
  CapacitorBarcodeScannerCameraDirection,
  CapacitorBarcodeScannerOptions,
  CapacitorBarcodeScannerTypeHintALLOption,
} from '@capacitor/barcode-scanner';
import { CapacitorBarcodeScannerScanOrientation } from '@capacitor/barcode-scanner/dist/esm/definitions';
import { CameraDeviceDataService } from '@vi-succ/sparepart-domain';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class EtCameraDeviceDataService implements CameraDeviceDataService {
  private readonly CAMERA_DEVICE_STORAGE_KEY = 'camera_device';

  constructor(private storageService: StorageService) {}

  getSelectedScanDevice(): Observable<MediaDeviceInfo | undefined> {
    return fromPromise(this.storageService.get<MediaDeviceInfo>(this.CAMERA_DEVICE_STORAGE_KEY));
  }

  selectScanDevice(device: MediaDeviceInfo): Observable<MediaDeviceInfo> {
    return fromPromise(this.storageService.set<MediaDeviceInfo>(this.CAMERA_DEVICE_STORAGE_KEY, device));
  }

  scan() {
    const options: CapacitorBarcodeScannerOptions = {
      hint: CapacitorBarcodeScannerTypeHintALLOption.ALL,
      cameraDirection: CapacitorBarcodeScannerCameraDirection.BACK,
      scanOrientation: CapacitorBarcodeScannerScanOrientation.PORTRAIT,
      android: {
        scanningLibrary: CapacitorBarcodeScannerAndroidScanningLibrary.MLKIT,
      },
      web: {
        showCameraSelection: true,
      },
    };

    return fromPromise(CapacitorBarcodeScanner.scanBarcode(options).then((result) => result.ScanResult));
  }
}
